export const WIDGET_LAYOUTS = [
    "vertical",
    "horizontal",
];
export const DEFAULT_WIDGET_LAYOUT = "vertical";
export function isMedosWidgetLayout(value) {
    return (typeof value === "string" &&
        WIDGET_LAYOUTS.includes(value));
}
export function resolveWidgetLayout(value) {
    if (value === undefined || value === null)
        return DEFAULT_WIDGET_LAYOUT;
    if (!isMedosWidgetLayout(value)) {
        console.warn(`[Medos] Ignoring unknown layout "${String(value)}". ` +
            `Expected one of: ${WIDGET_LAYOUTS.join(", ")}.`);
        return DEFAULT_WIDGET_LAYOUT;
    }
    return value;
}
export function resolveDoctorListPlacement(input) {
    const listAvailable = input.isScheduleStep &&
        !input.calendarOnly &&
        !input.isSolo &&
        input.hasWorkspace &&
        input.locationChosen &&
        !input.noVisibleDoctors;
    if (!listAvailable)
        return "none";
    if (input.compact)
        return "top";
    return input.layout === "horizontal" && !input.isMobile ? "side" : "top";
}
